import helthBenifitLeft from "./assets/benifit-left.png";
import helthBenifitRight from "./assets/benifit-right.png";
import mascotImage from "./assets/bottom-home.png";
import carBenefitsImage from "./assets/car-insurance-benifits.png";
import carHeroImage from "./assets/car-insurance.png";
import healthHeroImage from "./assets/health-insurance.png";
import healthCatDesktop from "./assets/heroinsurehub.png";
import homeHeroImage from "./assets/home-insurance.png";
import { default as documentSidebarMascot, default as heroImage } from "./assets/new.png";
import aigCardLogo from "./assets/partners/AIG_02.jpg";
import gigLogo from "./assets/partners/GIG_04.png";
import livaLogo from "./assets/partners/Liva_03.png";
import rakInsuranceLogo from "./assets/partners/RAKInsurance_01.png";
import aedSymbol from "./assets/partners/UAE_Dirham_Symbol.png";
import dniLogo from "./assets/partners/dni.jpg";
import livaPartnerLogo from "./assets/partners/liva.jpg";
import mastercardLogo from "./assets/partners/mastercard__1755783880000.png";
import metlifeGulfLogo from "./assets/partners/metlife-gulf.png";
import orientInsuranceLogo from "./assets/partners/orient-insurance.png";
import pciLogo from "./assets/partners/pci__1755783880000.png";
import qicLogo from "./assets/partners/qic.jpg";
import rakPartnerLogo from "./assets/partners/rak.jpg";
import salamaLogo from "./assets/partners/salama.jpg";
import SukoonLogo from "./assets/partners/sukoon.jpg";
import visaLogo from "./assets/partners/visa__1755783880000.png";
import zurichInternationalLifeLogo from "./assets/partners/zurich-international-life.png";
import quoteHowItWorksImage from "./assets/product-travel.png";
import ChatRobot from "./assets/publiclogos/chatbot-icon.jpg";
import Favicon from "./assets/publiclogos/favicon.jpeg";
import BrandLogo from "./assets/publiclogos/insureHubN.png";
import whatappLogo from "./assets/publiclogos/whatsapp-icon.png";
import saveTimeIcon from "./assets/save-time.png";
import sliderPrimarySecondaryCoverage from "./assets/sliders/Travel1PrimarySecondaryCoverage.png";
import sliderCancelForAnyReason from "./assets/sliders/Travel2CancelForAnyReason.png";
import sliderPreExistingWindow from "./assets/sliders/Travel3PreExistingWindow.png";
import travelBenefitsImage from "./assets/travel-benifits-btm.png";
import travelHeroImage from "./assets/travel-insurance.png";
import uploadIllustration from "./assets/upload_file.png";
import whyChooseUsImage from "./assets/why-section.png";

export const whiteLabelResources = {
  App_Url: {
    public: {
      Whatsapp: whatappLogo,
      BrandLogo: BrandLogo,
      ChatBot: ChatRobot,
      Favicon: Favicon,
    },
    homePage: {
      HeroImage: heroImage,
      WhyChooseUsImage: whyChooseUsImage,
      MascotImage: mascotImage,
    },
    products: {
      CarImage: carHeroImage,
      HomeImage: homeHeroImage,
      TravelImage: travelHeroImage,
      HealthImage: healthHeroImage,
    },
    quoteFlow: {
      UploadIllustration: uploadIllustration,
      SaveTimeIcon: saveTimeIcon,
      DocumentSidebarMascot: documentSidebarMascot,
      TravelSliders: {
        PrimarySecondaryCoverage: sliderPrimarySecondaryCoverage,
        CancelForAnyReason: sliderCancelForAnyReason,
        PreExistingWindow: sliderPreExistingWindow,
      },
    },
    insurancePages: {
      car: {
        HeroImage: carHeroImage,
        HowItWorksImage: carBenefitsImage,
      },
      travel: {
        HeroImage: travelHeroImage,
        BenefitsImage: travelBenefitsImage,
        HowItWorksImage: quoteHowItWorksImage,
      },
      health: {
        HeroImage: healthCatDesktop,
        BenefitCatImage: helthBenifitLeft,
        BenefitDrImage: helthBenifitRight,
      },
    },
    partners: {
      carousel: {
        Rak: rakPartnerLogo,
        Qic: qicLogo,
        Dni: dniLogo,
        Salama: salamaLogo,
        Liva: livaPartnerLogo,
      },
      insurers: {
        RakInsurance: rakInsuranceLogo,
        AurumInsurance: BrandLogo,
        Qic: qicLogo,
        Salama: salamaLogo,
        Liva: livaLogo,
        Aig: aigCardLogo,
        Gig: gigLogo,
        DniInsurance: dniLogo,
        Sokoon: SukoonLogo,
        OrientInsurance: orientInsuranceLogo,
        MetLifeGulf: metlifeGulfLogo,
        ZurichInternationalLife: zurichInternationalLifeLogo,
      },
      payments: {
        Mastercard: mastercardLogo,
        Visa: visaLogo,
        Pci: pciLogo,
      },
      symbols: {
        Aed: aedSymbol,
      },
    },
  },
} as const;
